import BlockRegionsEditor from '../BlockRegionsEditor';
import FilenamePatternField from '../../filename/FilenamePatternField';
import styles from '../blocks.module.css';

/**
 * Block name + region membership (add/remove). Distinct from region details.
 */
export default function BlockMembershipView({
    name,
    onNameChange,
    isEditMode,
    blockName,
    caseScoped = false,
    selectedRegionRefs,
    blockRegions,
    onToggleRegion,
    onConfigureRegion,
    disabled = false,
    statusMessage = null,
    highlightSchemaKey = null,
    nameDirty = false,
    onSaveName = null,
    saveNamePending = false,
    filenamePattern = '',
    onFilenamePatternChange,
    onSaveFilenamePattern,
    filenamePatternDirty = false,
    savePatternPending = false,
    currentCaseNetworkId = null,
}) {
    const help = caseScoped
        ? `Regions available when assigning slides to block ${blockName || name || '…'} on this case.`
        : `Regions available when assigning slides to block ${blockName || name || '…'}.`;

    const handleNameKeyDown = (e) => {
        if (e.key !== 'Enter') return;
        if (!isEditMode || !nameDirty || !onSaveName || disabled) return;
        e.preventDefault();
        onSaveName();
    };

    return (
        <div>
            <div className={styles.formRow}>
                <label className={styles.formLabel} htmlFor="block-map-name">
                    Block name *
                </label>
                <div className={styles.nameRow}>
                    <input
                        id="block-map-name"
                        type="text"
                        className={`${styles.input} ${styles.nameInput} ${nameDirty ? styles.inputDirty : ''}`}
                        value={name}
                        onChange={(e) => onNameChange?.(e.target.value)}
                        onKeyDown={handleNameKeyDown}
                        placeholder="e.g. A, K, Frontal"
                        disabled={disabled}
                        autoFocus
                    />
                    {isEditMode && onSaveName && (
                        <button
                            type="button"
                            className={styles.buttonPrimary}
                            onClick={onSaveName}
                            disabled={disabled || !nameDirty || !(name || '').trim()}
                        >
                            {saveNamePending ? 'Saving…' : 'Save'}
                        </button>
                    )}
                </div>
                {nameDirty && (
                    <p className={styles.dirtyHint} role="status">
                        Unsaved name — click Save (or press Enter) to keep it.
                    </p>
                )}
            </div>

            <p className={styles.jobText} style={{ marginBottom: '0.75rem' }}>{help}</p>

            {statusMessage && (
                <div className={styles.statusBanner} role="status">{statusMessage}</div>
            )}

            <BlockRegionsEditor
                isEditMode={isEditMode}
                selectedRegionRefs={selectedRegionRefs}
                blockRegions={blockRegions}
                onToggleRegion={onToggleRegion}
                onConfigureRegion={onConfigureRegion}
                disabled={disabled}
                highlightSchemaKey={highlightSchemaKey}
                caseScoped={caseScoped}
            />

            <FilenamePatternField
                value={filenamePattern}
                onChange={onFilenamePatternChange}
                disabled={disabled}
                showSaveButton={isEditMode && !!onSaveFilenamePattern}
                onSave={onSaveFilenamePattern}
                dirty={filenamePatternDirty}
                savePending={savePatternPending}
                variant="sheet"
                currentCaseNetworkId={currentCaseNetworkId}
            />
        </div>
    );
}
